import axios from "@/global/request/axios";
import API from "@/global/request/api";
import Cookies from "js-cookie";

export default {
  /*
   ** upload(params, progressHandle)
   **
   ** @params progressHandle  {function}   上传事件回调
   */
  async upload({ file }, progressHandle) {
    const fileName = file.file.name;
    // 获取 token
    const tokenInfo = await this.fetchToken({
      fileName
    });
    const formData = new FormData();
    formData.append("key", tokenInfo.dir + fileName);
    formData.append("OSSAccessKeyId", tokenInfo.accessid);
    formData.append("policy", tokenInfo.policy);
    formData.append("signature", tokenInfo.signature);
    formData.append("file", file.file);
    formData.append("success_action_status", 200);
    formData.append("x-oss-security-token", Cookies.get("shiguang_token"));
    const imgUrl = tokenInfo.host + "/" + tokenInfo.dir + fileName;
    // 上传oss
    await this.uploadFileOss(formData, progressHandle);
    // 上报信息
    const store = await this.sendStore({
      file_src: imgUrl,
      file_name: fileName
    });
    return Promise.resolve({
      name: fileName,
      path: imgUrl,
      id: store.file_id
    });
  },
  /* 获取阿里的token和key
   ** @params bucket           {string}       桶
   ** @params fileName         {string}       文件名
   ** @params space            {string}       空间
   ** @params folder           {string}       文件夹
   */
  fetchToken({ fileName }) {
    return axios.get(API.ossToken, { filename: fileName });
  },
  /* 发送文件到阿里上
   ** @params key               {string}       文件名
   ** @params token             {string}       空间
   ** @params file              {string}       文件夹
   ** @params onUploadProgress  {function}     上传回调
   */
  uploadFileOss(formData, onUploadProgress) {
    const headers = { "Content-type": "multipart/form-data" };
    return axios.post(API.ossUrl, formData, {
      withCredentials: false,
      timeout: 1800000,
      headers,
      onUploadProgress
    });
  },
  // 本地上报信息
  sendStore({ file_src, file_name }) {
    return axios.post(API.ossStore, {
      file_src,
      file_name
    });
  }
};
